import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import Button from "../../components/Button";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import {
  checkContentAvlInArray,
  //  dataDashboard
} from "../../util";
import Footer from "../../components/Footer/Footer";
import {setCustomerDetails, setIsLoggedInUser} from "../../actions/customer";
import guestLandingWelcomeImg from "../../images/guest_welcome_img.svg";

import config from "../../../config";

const LoggedInLandingPage = () => {
  const {t} = useTranslation();
  let customerSlotDetails = getCustomerSlotDetails();
  const navigate = useNavigate();
  const isTurneroEnabled = config.turnero_enabled_bu_list.includes(
    customerSlotDetails.bu
  );
  const [userLoggedIn, setUserLoggedIn] = useState(false);

  const [buLinkSource, setBuLinkSource] = useState(null);
  const [isTurneroBuText, setIsTurneroBuText] = useState(null);

  const dispatch = useDispatch();

  const {origin} = useSelector((state) => {
    return {
      origin: state.customerReducer?.customerDetails?.origin || null,
    };
  });

  const navigateTOselectionPage = () => {
    if (isTurneroEnabled) {
      navigate("/customer/selectTurneroStoreAndType");
    } else if (
      checkContentAvlInArray(
        config.stand_alone_bu_list,
        customerSlotDetails.buList
      )
    ) {
      navigate("/customer/selectMallStore");
    } else {
      navigate("/customer/selectStore");
    }
  };

  useEffect(() => {
    const customerSlotDetails = getCustomerSlotDetails();
    dispatch(setCustomerDetails(customerSlotDetails || null));
    if (customerSlotDetails.userId) {
      setUserLoggedIn(true);
      dispatch(setIsLoggedInUser(true));
    }
    if (
      config.turnero_enabled_bu_list?.includes(getCustomerSlotDetails()?.bu)
    ) {
      setIsTurneroBuText(".turnero");
    } else {
      setIsTurneroBuText("");
    }
  }, []);

  useEffect(() => {
    if (origin) {
      const type = origin || null;
      setBuLinkSource(type);
    }
  }, [origin]);

  // useEffect(() => {
  //   let timer = setTimeout(() => {
  //     // for data dashboard
  //     const URL = window.location.href.split("/")[2];
  //     const officeApp = customerSlotDetails.isOffice
  //       ? URL + "/office"
  //       : URL + "/app";
  //     const datamap = new Map();
  //     datamap.set("pageName", ADOBEDTM_PAGE_NAME.Loggedin_User);
  //     datamap.set("prop1", URL);
  //     datamap.set("prop2", officeApp);
  //     dataDashboard(datamap);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }, 1000);
  // }, []);

  const isBancoChile = () => {
    if (customerSlotDetails.source.includes("bancofalabella")) {
      return true;
    } else {
      return false;
    }
  };

  const isBancoOrMalls = () => {
    if (
      customerSlotDetails.source.includes("bancofalabella") ||
      checkContentAvlInArray(
        config.stand_alone_bu_list,
        customerSlotDetails.buList
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="guestLandingPage-container">
      {buLinkSource?.toLowerCase() === "web" ? <BuSpecificHeader /> : null}
      <div className="guestPage">
        {isBancoChile() ? (
          <label className="guestPage-helloText">
            {t(`welcome${isTurneroBuText}`)}
          </label>
        ) : (
          <>
            <label className="guestPage-helloText">
              {t(`welcome${isTurneroBuText}`)}
            </label>
            <label className="guestPage-detail-text">
              {isTurneroEnabled
                ? t("turneroenabled.bookingDisabled.entryText")
                : customerSlotDetails.bu === "Car Center"
                ? t("nonturnero.selectionPage.entryText.Carcenter")
                : t("nonturnero.selectionPage.entryText")}
            </label>
          </>
        )}
        {config.turnero_enabled_bu_list.includes(
          getCustomerSlotDetails()?.bu
        ) && (
          <img
            className="guestPage-welcome-img"
            src={guestLandingWelcomeImg}
            alt="img"
          />
        )}
        <Button
          disabled={!userLoggedIn}
          newDesign={true}
          handleClick={navigateTOselectionPage}
          customClass="spaceAround"
          value={
            isBancoOrMalls()
              ? t("proceed.label")
              : isTurneroEnabled
              ? t("book.shift")
              : t("login.label")
          }
        />
      </div>
      <Footer isTurneroBuText={isTurneroBuText} />
    </div>
  );
};
export default LoggedInLandingPage;
